
  import * as noneRuntime$pLvVUlq4vuWa_uv3azf5f9pdZquy3tJ839di_M6Dc3s from '/Users/bartligthart/Documents/Vue/juistemakelaar/node_modules/@nuxt/image/dist/runtime/providers/none'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['none']: { provider: noneRuntime$pLvVUlq4vuWa_uv3azf5f9pdZquy3tJ839di_M6Dc3s, defaults: {} }
    }
  }
